import type { GetCanvasQaRunResult } from "./types";

/**
 * Lenient guard for the GET response. The run is null when the developer has no
 * saved run; otherwise it's the persisted record. We intentionally don't
 * deep-validate the freeform results blob (the QA agents own its shape).
 */
export const isGetCanvasQaRunResult = (value: unknown): value is GetCanvasQaRunResult => {
  if (value === null || typeof value !== "object") {
    return false;
  }
  const run = (value as { run?: unknown }).run;
  return run === null || run === undefined || typeof run === "object";
};
